import "./TechStack.scss";

import JavascriptLogo from "../../images/javascript-logo.svg";
import ReactLogo from "../../images/react-logo.svg";
import ReactNativeLogo from "../../images/react-native-logo.svg";
import ScssLogo from "../../images/sass-logo.svg";
import TypescriptLogo from "../../images/typescript-logo.svg";
import AngularLogo from "../../images/angular-logo.svg";
import GithubLogo from "../../images/github-logo-black.svg";

const TechStack = () => {
  return (
    <div className="tech-stack__container">
      <div className="tech-stack__row">
        <div className="tech-stack__entry">
          <img
            className="tech-stack__entry-logo"
            src={JavascriptLogo}
            alt="JavaScript"
          />
          <div className="tech-stack__entry-details">
            <h5 className="tech-stack__entry-details--name">JavaScript</h5>
            <p>Strong JS knowledge and advanced web development.</p>
          </div>
        </div>

        <div className="tech-stack__entry">
          <img className="tech-stack__entry-logo" src={ReactLogo} alt="React" />
          <div className="tech-stack__entry-details">
            <h5 className="tech-stack__entry-details--name">React</h5>
            <p>Building fast and efficient React Apps and websites.</p>
          </div>
        </div>

        <div className="tech-stack__entry">
          <img
            className="tech-stack__entry-logo"
            src={ReactNativeLogo}
            alt="React Native"
          />
          <div className="tech-stack__entry-details">
            <h5 className="tech-stack__entry-details--name">React Native</h5>
            <p>
              Building cross-platform mobile applications for iOS and Android.
            </p>
          </div>
        </div>

        <div className="tech-stack__entry">
          <img className="tech-stack__entry-logo" src={ScssLogo} alt="SCSS" />
          <div className="tech-stack__entry-details">
            <h5 className="tech-stack__entry-details--name">CSS/SASS</h5>
            <p>I use SASS as my preferred CSS pre-processor</p>
          </div>
        </div>

        <div className="tech-stack__entry">
          <img
            className="tech-stack__entry-logo"
            src={AngularLogo}
            alt="Angular"
          />
          <div className="tech-stack__entry-details">
            <h5 className="tech-stack__entry-details--name">Angular</h5>
            <p>Building fast and efficient Angular Apps and websites.</p>
          </div>
        </div>

        <div className="tech-stack__entry">
          <img
            className="tech-stack__entry-logo"
            src={TypescriptLogo}
            alt="TypeScript"
          />
          <div className="tech-stack__entry-details">
            <h5 className="tech-stack__entry-details--name">TypeScript</h5>
            <p>Strong TS knowledge and advanced web development.</p>
          </div>
        </div>

        <div className="tech-stack__entry">
          <img
            className="tech-stack__entry-logo"
            src={GithubLogo}
            alt="GitHub"
          />
          <div className="tech-stack__entry-details">
            <h5 className="tech-stack__entry-details--name">GitHub</h5>
            <p>I leverage GitHub for version control</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechStack;
